module.exports = __webpack_public_path__ + "img/error-desert-landscape.3eb9d627.svg";